var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isViewOnly)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.nl2br(_vm.value))}}):_c('textarea',{staticStyle:{"box-sizing":"border-box"},domProps:{"value":_vm.value},on:{"input":_vm.onTextChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }